import React, { useEffect, useState, useRef } from 'react';
import { gridCol } from 'utils/global';

import { ChevronDoubleDown, ChevronDoubleUp } from 'react-bootstrap-icons';

import './CardBox2.scss';

const CardBox2 = ({
  children,
  title,
  image,
  imageTitle,
  link,
  style,
  limit = 30,
}) => {
  const selfRef = useRef();
  const [isFull, setIsFull] = useState(false);

  useEffect(() => {
    const box = selfRef.current;

    const fullTextElement = box.querySelector('.full-text');
    const shortTextElement = box.querySelector('.short-text');
    const toggleTextLink = box.querySelector('.toggle-text');
    const fullTextContent = fullTextElement.innerHTML;
    const words = fullTextContent.split(' ');

    if (words.length > limit) {
      const shortText = words.slice(0, limit).join(' ') + '...';
      shortTextElement.innerHTML = shortText;
      fullTextElement.style.display = 'none';
    } else {
      shortTextElement.innerHTML = fullTextContent;
      toggleTextLink.style.display = 'none';
    }

    const onToggleLinkClick = (event) => {
      event.preventDefault();

      if (fullTextElement.style.display === 'none') {
        fullTextElement.style.display = 'block';
        shortTextElement.style.display = 'none';
        setIsFull(true);
      } else {
        fullTextElement.style.display = 'none';
        shortTextElement.style.display = 'block';
        setIsFull(false);
      }
    };

    toggleTextLink.addEventListener('click', onToggleLinkClick);

    return () => {
      toggleTextLink.removeEventListener('click', onToggleLinkClick);
    };
  }, []);

  return (
    <div className={gridCol(style)} ref={selfRef}>
      <div className="card-box">
        <img
          src={require(`assets/images/${image}`)}
          className="img-fluid mx-auto"
          alt={imageTitle}
        />

        <h3>{title}</h3>

        <div className="bline"></div>

        <p className="full-text">
          {children}

          <a className="read-more" href={link} target="_blank">
            Learn more...
          </a>
        </p>

        <p className="short-text"></p>

        <button className="toggle-text">
          {isFull ? <ChevronDoubleUp /> : <ChevronDoubleDown />}
        </button>
      </div>
    </div>
  );
};

export default CardBox2;
